import React from 'react';
import { useTranslation } from 'react-i18next';
import { pickLocaleText } from '../../utils/publicPagesDefaults';
import PrivacyRightsContact from './PrivacyRightsContact';
import {
  HighlightBox,
  List,
  Section,
  SectionTitle,
  Text,
  TextNoMargin
} from './PublicLegalPageLayout';

export default function PrivacyLegalContent({ sections, meta }) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;
  const list = Array.isArray(sections) ? sections : [];

  if (!list.length) {
    return (
      <Section>
        <Text>{t('privacyPage.intro.text')}</Text>
      </Section>
    );
  }

  return (
    <>
      {meta && (
        <HighlightBox>
          <TextNoMargin>
            <strong>{t('privacyPage.lastUpdatedHighlight')}</strong>{' '}
            {meta.lastUpdated}
            {meta.version ? ` — v${meta.version}` : ''}
            {meta.effectiveDate ? (
              <>
                <br />
                <strong>{t('publicPages.privacy.effectiveLabel')}</strong> {meta.effectiveDate}
              </>
            ) : null}
          </TextNoMargin>
        </HighlightBox>
      )}

      {list.map((section) => (
        <Section key={section.id}>
          <SectionTitle>{pickLocaleText(section.title, locale)}</SectionTitle>
          {(section.blocks || []).map((block, index) => {
            if (block.type === 'list') {
              return (
                <List key={`${section.id}-list-${index}`}>
                  {(block.items || []).map((item, ii) => (
                    <li key={`${section.id}-li-${ii}`}>{pickLocaleText(item, locale)}</li>
                  ))}
                </List>
              );
            }
            if (block.type === 'rightsContact') {
              return (
                <PrivacyRightsContact
                  key={`${section.id}-rights-${index}`}
                  introText={pickLocaleText(block.text, locale)}
                />
              );
            }
            return (
              <Text key={`${section.id}-p-${index}`}>{pickLocaleText(block.text, locale)}</Text>
            );
          })}
        </Section>
      ))}
    </>
  );
}
